import React from "react";
import { SORTING } from "../../../../../constants/sorting";

const useSorting = (sortingKeys, defaults = null) => {
	const [sortingState, setSortingState] = React.useState(
		Object.fromEntries(
			sortingKeys.map(v => {
				const direction =
					defaults && v === defaults?.defaultSortingKey
						? defaults.defaultSortingDirection
						: SORTING.DIRECTIONS.DESC;
				return [v, direction];
			})
		)
	);
	const [currentSorting, setCurrentSorting] = React.useState(
		defaults?.defaultSortingKey || null
	);

	const toggleSorting = React.useCallback(({ column, direction }) => {
		setCurrentSorting(column);
		setSortingState(current => {
			return {
				...Object.fromEntries(
					Object.entries(current).map(([k, v]) => [
						k,
						v || SORTING.DIRECTIONS.DESC
					])
				),
				[column]: direction
			};
		});
	}, []);

	return {
		sortingState,
		toggleSorting,
		currentSorting
	};
};

export default useSorting;
